/* Portfolio content sourced from Ahmed Al-Zahrani's current CV. */

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation";

const splashScreen = {
  enabled: true,
  animation: splashAnimation,
  duration: 2000
};

const illustration = {
  animated: true
};

const greeting = {
  username: "Ahmed Al-Zahrani",
  title: "Hi, I'm Ahmed",
  subTitle: emoji(
    "Software engineer and .NET developer building secure web systems for healthcare, retail, and consumer services. I take projects from requirements and solution planning through development, IIS deployment, and production support."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1BMx30pfaf_8Gv7EifFOqX1Kp4G7NShUI/view?usp=sharing",
  displayGreeting: true
};

const socialMediaLinks = {
  github: "https://github.com/alahmad0333",
  linkedin: "https://www.linkedin.com/in/zahrani/",
  gmail: "ahmadali_@outlook.sa",
  display: true
};

const skillsSection = {
  title: "What I do",
  subTitle:
    "BACKEND SOFTWARE ENGINEER SPECIALIZING IN SECURE .NET SYSTEMS AND ENTERPRISE INTEGRATIONS",
  skills: [
    emoji(
      "⚡ Build secure ASP.NET Core MVC and Web API applications with role-based access, audit trails, bilingual experiences, and dynamic workflows"
    ),
    emoji(
      "⚡ Integrate ERP platforms, Nafath and Absher, SharePoint, Odoo, NAV, SMS gateways, reporting tools, and REST APIs"
    ),
    emoji(
      "⚡ Deliver and support production systems on IIS and Windows Server, including deployments, domains, performance, security, and availability"
    )
  ],
  softwareSkills: [
    {
      skillName: "C#",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: ".NET 8",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "ASP.NET Core",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "REST APIs",
      fontAwesomeClassname: "fas fa-project-diagram"
    },
    {
      skillName: "SQL Server",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Oracle Database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Azure",
      fontAwesomeClassname: "fab fa-microsoft"
    },
    {
      skillName: "Windows Server & IIS",
      fontAwesomeClassname: "fab fa-windows"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    }
  ],
  display: true
};

const educationInfo = {
  display: true,
  schools: [
    {
      schoolName: "Arab Open University",
      logo: require("./assets/images/1673099746308.jpeg"),
      subHeader: "Bachelor's Degree in Computer Science",
      duration: "October 2022 - Present",
      descBullets: [
        "Relevant coursework includes algorithms, data structures, software architecture, Java, C++, and Python."
      ]
    },
    {
      schoolName: "Institute of Public Administration",
      logo: require("./assets/images/ipa.png"),
      subHeader: "Associate Degree in Computer Programming",
      duration: "June 2019 - December 2021",
      descBullets: [
        "Key studies included C#, web development, databases, object-oriented programming, data structures, systems analysis, and software security."
      ]
    }
  ]
};

const techStack = {
  viewSkillBars: false,
  experience: [],
  displayCodersrank: false
};

const workExperiences = {
  display: true,
  experience: [
    {
      role: "Software Engineer",
      company: "Netways",
      companylogo: require("./assets/images/Netways.jpg"),
      date: "August 2024 - Present",
      desc:
        "Designing and delivering secure web applications for King Fahad Armed Forces Hospital, from gathering requirements and planning solutions through deployment and support.",
      descBullets: [
        "Build approval workflows and integrations using Nafath and Absher, ERP, SharePoint, SMS, reports, and role-based access.",
        "Manage IIS deployments, domains, servers, performance, security, and system availability to keep hospital services reliable."
      ]
    },
    {
      role: "IT Support Coordinator / .NET Developer",
      company: "Munch Bakery",
      companylogo: require("./assets/images/1667460541463.jpeg"),
      date: "July 2022 - July 2024",
      desc:
        "Built internal web systems connecting Odoo POS, NAV ERP, CRM, sales, purchasing, and maintenance operations.",
      descBullets: [
        "Managed IIS, Windows Server, domains, networks, devices, backups, and website deployments while resolving production issues.",
        "Supervised computer operators and worked with vendors to keep daily IT operations running smoothly."
      ]
    },
    {
      role: "Backend Developer (Part Time)",
      company: "BeautyHub",
      companylogo: require("./assets/images/beautyHub-logo.png"),
      date: "June 2023 - July 2024",
      desc:
        "Built ASP.NET Core APIs and an admin portal for a salon marketplace, including payment and SMS integrations.",
      descBullets: [
        "Designed and improved databases, deployed applications to IIS, and worked with the startup team to deliver secure and stable releases."
      ]
    }
  ]
};

const openSource = {
  showGithubProfile: "false",
  display: false
};

const bigProjects = {
  title: "Projects",
  subtitle:
    "SECURE HEALTHCARE SYSTEMS, BUSINESS PLATFORMS, AND ENTERPRISE INTEGRATIONS",
  projects: [
    {
      image: require("./assets/images/Netways.jpg"),
      projectName: "Patient Services Portal",
      projectDesc:
        "A unified portal for patient and hospital services with dynamic approvals, Nafath authentication, ERP patient search, SMS alerts, Arabic and English support, audit logs, secure attachments, dashboards, and PDF/QR reports. Built with .NET 8, ASP.NET Core MVC, EF Core, and SQL Server.",
      footerLink: [
        {
          name: "Visit Portal",
          url: "https://gen.kfafh.med.sa"
        }
      ]
    },
    {
      image: require("./assets/images/Netways.jpg"),
      projectName: "HR Management System",
      projectDesc:
        "An HR platform that replaced paper processes for three employee groups and automated leave, balances, official letters, scholarships, assignments, delegations, reports, and approval rules with ERP and Nafath integration.",
      footerLink: []
    },
    {
      image: require("./assets/images/Netways.jpg"),
      projectName: "Housing Management System",
      projectDesc:
        "A Domain-Driven Design based housing allocation system with multi-step approvals and a structured model spanning compounds, buildings, apartments, rooms, and beds.",
      footerLink: []
    },
    {
      image: require("./assets/images/Netways.jpg"),
      projectName: "Hospital Training Management System",
      projectDesc:
        "A medical and administrative training request platform with role-based approvals, end-to-end status tracking, operational dashboards, SharePoint, Absher, and SMS integrations.",
      footerLink: [
        {
          name: "Visit System",
          url: "https://gen.kfafh.med.sa/training"
        }
      ]
    },
    {
      image: require("./assets/images/1667460541463.jpeg"),
      projectName: "Order Management Integration Platform",
      projectDesc:
        "A platform connecting order management and CRM workflows across sales channels with reliable processing, REST APIs, and clear status tracking.",
      footerLink: []
    },
    {
      image: require("./assets/images/1667460541463.jpeg"),
      projectName: "Sales Data Synchronization",
      projectDesc:
        "A .NET service that moves daily Odoo sales totals and item details into EDSS with date-range processing, safe re-runs, correct tax handling, branch-level processing, and database transactions.",
      footerLink: []
    },
    {
      image: require("./assets/images/1667460541463.jpeg"),
      projectName: "Odoo POS API Integration",
      projectDesc:
        "APIs connecting order processing with Odoo POS to make data exchange between systems more reliable and easier to operate.",
      footerLink: []
    },
    {
      image: require("./assets/images/1667460541463.jpeg"),
      projectName: "NAV ERP Integration",
      projectDesc:
        "Connected NAV ERP with Odoo POS so retail and back-office teams could share consistent order data.",
      footerLink: []
    },
    {
      image: require("./assets/images/1667460541463.jpeg"),
      projectName: "Munch Approval",
      projectDesc:
        "A purchase and maintenance request system with flexible approval workflows, an administrative dashboard, and accounting email alerts.",
      footerLink: []
    },
    {
      image: require("./assets/images/1667460541463.jpeg"),
      projectName: "Maintenance Tracking Website",
      projectDesc:
        "A web application for recording and tracking factory maintenance work, improving operational visibility, status reporting, and follow-up.",
      footerLink: []
    },
    {
      image: require("./assets/images/beautyHub-logo.png"),
      projectName: "BeautyHub App",
      projectDesc:
        "Backend APIs and an administrative portal for a salon-discovery application, including secure APIs, payment and SMS integrations, data tools, and salon-owner features.",
      footerLink: []
    }
  ],
  display: true
};

const achievementSection = {
  title: emoji("Licenses & Certifications 🏆"),
  subtitle: "PROFESSIONAL TRAINING IN .NET, WEB APIs, C#, AND PYTHON",
  achievementsCards: [
    {
      title: "Build ASP.NET Core Web API - Scratch To Finish (.NET 7 API)",
      image: require("./assets/images/udemy-logo-vector-2022.png"),
      imageAlt: "Udemy logo",
      subtitle: "Udemy - April 2023",
      footerLink: [
        {
          name: "View Credential",
          url: "https://www.udemy.com/certificate/UC-93195561-add7-4a64-a947-3d9bfa9ca06a/"
        }
      ]
    },
    {
      title: "ASP.NET Core MVC (.NET 6)",
      image: require("./assets/images/FreeCodeCamp_logo.png"),
      imageAlt: "freeCodeCamp logo",
      subtitle: "freeCodeCamp - December 2022",
      footerLink: []
    },
    {
      title: "Developing ASP.NET MVC Web Applications",
      image: require("./assets/images/1670196327149.jpeg"),
      imageAlt: "SAFCSP logo",
      subtitle: "Saudi Federation for Cybersecurity, Programming and Drones - September 2022",
      footerLink: []
    },
    {
      title: "Development Using C#",
      image: require("./assets/images/1670196327149.jpeg"),
      imageAlt: "SAFCSP logo",
      subtitle: "Saudi Federation for Cybersecurity, Programming and Drones - July 2022",
      footerLink: []
    },
    {
      title: "Introduction to Programming Using Python",
      image: require("./assets/images/1670196327149.jpeg"),
      imageAlt: "SAFCSP logo",
      subtitle: "Saudi Federation for Cybersecurity, Programming and Drones - January 2022",
      footerLink: []
    }
  ],
  display: true
};

const blogSection = {
  title: "Blogs",
  subtitle: "Articles and notes about software development.",
  displayMediumBlogs: "false",
  blogs: [],
  display: false
};

const talkSection = {
  title: "Talks",
  subtitle: "Technical talks and presentations.",
  talks: [],
  display: false
};

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "Podcast appearances and technical conversations.",
  podcast: [],
  display: false
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Have a software project, integration challenge, or opportunity to discuss? My inbox is open.",
  number: "+966 50 942 4245",
  email_address: "ahmadali_@outlook.sa"
};

const twitterDetails = {
  userName: "",
  display: false
};

const isHireable = false;

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};

